import {
  DestinationStatusEnum,
  DestinationTypeEnum,
} from "../../../enums/destination";
import { AllDestinations } from "../../../models";
import { ensureTrailingSlash } from "../../../utils";
import { secretKeyMask } from "./formValidationUtils";

export const generatePayload = (
  destination: AllDestinations,
  values: any,
  accountId: string
): AllDestinations => {
  const payload: any = {
    ...values,
    accountId,
    destination: {
      ...values.destination,
    },
  };

  delete payload.createdAt;
  delete payload.updatedAt;

  if (payload.destination.secretKey?.startsWith(secretKeyMask)) {
    payload.destination.secretKey = payload.destination.secretKey.replace(
      secretKeyMask,
      ""
    );
  }

  if (values.destinationTypeId === DestinationTypeEnum.WORDPRESS) {
    payload.url = ensureTrailingSlash(values.destination.url);
    payload.destination.postDelayHours =
      values.destination.status === DestinationStatusEnum.FUTURE
        ? values.destination.postDelayHours
        : null;
    payload.destination.randomPostHours =
      values.destination.status === DestinationStatusEnum.FUTURE
        ? values.destination.randomPostHours
        : null;
  }

  if (values.destinationTypeId === DestinationTypeEnum.SHOPIFY) {
    payload.destination.storeName = values.destination.storeName;
  }

  if (values.destinationId) {
    // if secret key is empty, reset to original
    if (!payload.destination.secretKey) {
      payload.destination.secretKey = destination.destination.secretKey;
    }
  }

  return payload;
};
